import {
    Button,
    LoadingOverlay,
    Modal,
    ModalProps,
    ButtonVariants,
} from '@tcc-online/common-components';
import { useTranslate } from 'react-translate.ts';

import { useSwitch } from '../../../hooks/useSwitch';
import styles from './ConsentDialog.module.scss';
import Dash from 'react-bootstrap-icons/dist/icons/dash';
import Plus from 'react-bootstrap-icons/dist/icons/plus';
import { TRANSLATIONS_ROOT_KEY } from '../../../constants/translation.constants';
import { mapParagraphs } from '../../../helpers/mapParagraphs';

interface ConsentDialogProps extends ModalProps {
    text?: string;
    moreText?: string;
    onConfirm: () => void;
    isLoading: boolean;
}

export default function ConsentDialog(props: ConsentDialogProps) {
    const { text, moreText, onConfirm, isLoading, ...rest } = props;
    const [collapsed, , , toggle] = useSwitch(true);
    const translate = useTranslate(
        TRANSLATIONS_ROOT_KEY + '.participant.consent',
    );

    return (
        <Modal
            classNames={{ modal: styles.modal, card: styles.card }}
            {...rest}
        >
            <LoadingOverlay isLoading={isLoading} />
            {mapParagraphs(text)}
            <br />
            <p className={styles.collapse} onClick={toggle}>
                <span>{translate('title')}</span>
                {collapsed ? <Plus /> : <Dash />}
            </p>
            <br />
            {!collapsed && mapParagraphs(moreText)}
            <div className={styles.buttons}>
                <Button variant={ButtonVariants.positive} onClick={onConfirm}>
                    {translate('confirm')}
                </Button>
            </div>
        </Modal>
    );
}
